import * as urls from "./url";
import client, { getHeader } from "../client";
import { interceptor, substituteEncrypted } from "../../util/util";

export const getCaseSupportCreatedVSClosed = (payload) =>
  interceptor(() => client.post(urls.CASESUPPORT_CREATED_CLOSED, substituteEncrypted(payload), getHeader()));
